import { PATHS } from './transformer/constants';
import type { ExtendedTransformedCmsConfigItem, ExtendedTransformedCmsConfigItemLevels } from './transformer/types';

export interface CategoriesMenuGroup {
    heading?: ExtendedTransformedCmsConfigItem;
    links: ExtendedTransformedCmsConfigItem[];
}

export const getCategories = (
    cmsCategories: ExtendedTransformedCmsConfigItemLevels,
    section: ExtendedTransformedCmsConfigItem
): ExtendedTransformedCmsConfigItem[] => cmsCategories.level_2?.[section.id] ?? [];

export const getCategoryGroups = (
    cmsCategories: ExtendedTransformedCmsConfigItemLevels,
    category: ExtendedTransformedCmsConfigItem
): CategoriesMenuGroup[] => {
    const children = cmsCategories.level_3?.[category.id] ?? [];
    const headings = children
        .map((heading) => ({ heading, links: cmsCategories.level_4?.[heading.id] ?? [] }))
        .filter(({ links }) => links.length > 0);

    return headings.length > 0 ? headings : [{ links: children }];
};

export const hasLink = ({ url }: Pick<ExtendedTransformedCmsConfigItem, 'url'>): boolean =>
    Boolean(url) && url !== PATHS.ROOT;
